import store from '@/store/store';

export default {
    namespaced: true,
    state: {
      verified: false,
    },
    getters: {
      verified: state => state.verified,
    },
    mutations: {
      verifiedMutate(state, data) {
        state.verified = data;
      },
    },
    actions: {
      setVerified(context, data) {
        context.commit('verifiedMutate', data);
      },
    },
};